import { Component, OnInit, Renderer2 } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePinComponent } from './change-pin/change-pin.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPinComponent } from './forgot-pin/forgot-pin.component';

@Component({
  selector: 'app-arcangel-settings',
  standalone: true,
  templateUrl: './arcangel-settings.component.html',
  styleUrl: './arcangel-settings.component.css'
})
export class ArcangelSettingsComponent implements OnInit {
  constructor(private modalService: NgbModal, private renderer: Renderer2) { }

  ngOnInit(): void { }
  forgotMyPin(): void {
    const modalRef = this.modalService.open(ForgotPinComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    setTimeout(() => {
      const modalWindow = document.querySelector('.ngb-modal-window');
      if (modalWindow) {
        this.renderer.removeClass(modalWindow, 'fade');
      }
    });

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );
  }
  changeMyPassword(): void {
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    setTimeout(() => {
      const modalWindow = document.querySelector('.ngb-modal-window');
      if (modalWindow) {
        this.renderer.removeClass(modalWindow, 'fade');
      }
    });

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );

  }
  changeMyPin(): void {
    const modalRef = this.modalService.open(ChangePinComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    setTimeout(() => {
      const modalWindow = document.querySelector('.ngb-modal-window');
      if (modalWindow) {
        this.renderer.removeClass(modalWindow, 'fade');
      }
    });

    modalRef.result.then(
      (result) => {
      },
      (reason) => {
      }
    );

  }
}